<section class="cart-checkout">
  <!--GAHR737 -->
  <div>
    <dx-popup
      [width]="625"
      [height]="'auto'"
      [showTitle]="false"
      title="{{ 'download-label' | translate }}"
      [dragEnabled]="false"
      [showTitle]="true"
      title="Download Asset"
      [showCloseButton]="true"
      [closeOnOutsideClick]="true"
      [showCloseButton]="true"
      container=".dx-viewport"
      [(visible)]="downloadPopupVisible"
      [wrapperAttr]="{ id: 'download-cart-popup' }"
      (onHiding)="popupHiding($event)"
    >
      <span class="download-popup-header"> {{ 'download-option-select' | translate }} </span>
      <ul>
        <li id="assetLabelInfoSection" class="asset-name">
          <strong class="popup__label">{{ assetLength }} Asset(s) selected</strong>
        </li>

        <li id="downloadSection" class="asset-name">
          <strong class="popup__label">{{ 'download-method-selection' | translate }} :</strong>
          <div class="downloadSelectionDiv">
            <mat-radio-group [(ngModel)]="selected">
              <div class="download_method_section" *ngFor="let downloadMethodObj of downloadMethod">
                <mat-radio-button
                  class="popup__label"
                  [checked]="downloadMethodObj.checked"
                  [value]="downloadMethodObj.key"
                  (change)="setDownloadTypeVal($event)"
                >
                  {{downloadMethodObj.key}}
                </mat-radio-button>
                <span
                  *ngIf="downloadMethodObj.key==='Aspera'"
                  (mouseenter)="showPopover()"
                  (mouseleave)="hidePopover()"
                >
                  <mat-icon id="aspera-icon-popover-{{assetRunnerId}}" class="icon__vertical_align">
                    info_outline</mat-icon
                  >
                </span>
              </div>
            </mat-radio-group>
            <em *ngIf="selected==='Standard'" class="download-guideline-font"
              >*Aspera is recommended for files larger than 100MB.</em
            >
          </div>
        </li>
      </ul>
      <mat-radio-group>
        <ul class="proxy-item-list" *ngFor="let proxyType of proxyArrayList;">
          <li id="proxyInfoSection" class="proxy-item">
            <div class="proxy-type">
              <mat-radio-button
                (change)="setProxyVal($event)"
                [value]="proxyType.resolution"
                class="popup__label"
                [checked]="proxyType.checked"
                [disabled]="proxyType.disabled"
              >
                {{proxyType.resolution}}
              </mat-radio-button>
            </div>
          </li>
        </ul>
      </mat-radio-group>
      <span class="download_popup_button_section">
        <button
          *ngIf="!isLoading"
          (click)="downloadAssetBasedOnProxySelection();"
          mat-button
          class="download_popup_button_color downloadButtonCart popup__label"
        >
          <mat-icon>cloud_download</mat-icon>
          {{ 'download-label' | translate }}
        </button>
        <button
          *ngIf="isLoading"
          mat-button
          class="download_popup_button_color downloadButtonCart popup__label"
          [class.spinner]="isLoading"
          disabled="true"
        >
          <mat-icon>cloud_download</mat-icon>
          {{ 'downloading-asset' | translate }}
        </button>
        <button
          mat-button
          class="download_popup_button_color cancel popup__label"
          (click)="hideDownloadPopup();"
        >
          <mat-icon>cancel</mat-icon>
          {{ 'cancel-label' | translate }}
        </button>
      </span>
    </dx-popup>
  </div>

  <dx-popover
    target="#aspera-icon-popover-{{assetRunnerId}}"
    position="bottom"
    width="350"
    [(visible)]="hoverPopup"
    [wrapperAttr]="{ id: 'aspera-popover' }"
  >
    <div
      *dxTemplate="let data = model; of: 'content'"
      class="aspera-popover__content"
      (mouseenter)="showPopover()"
      (mouseleave)="hidePopover()"
    >
      <dx-scroll-view showScrollbar="onScroll">
        <p>
          <span class="aspera-popover__title">{{ 'aspera-label' | translate }}:</span>
          <span class="aspera-popover__details">
            {{ 'aspera-download-guidelines' | translate }}
          </span>
        </p>
        <p>
          <span class="aspera-popover__title">{{ 'standard-label' | translate }}:</span>
          <span class="aspera-popover__details">
            {{ 'standard-download-guidelines' | translate }}
          </span>
        </p>
      </dx-scroll-view>
    </div>
  </dx-popover>
</section>
